var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeaveapprove(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #39da8a;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M58,43h22c1.1,0,2-.9,2-2s-.9-2-2-2h-22c-1.1,0-2,.9-2,2s.9,2,2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M58,33h22c1.1,0,2-.9,2-2s-.9-2-2-2h-22c-1.1,0-2,.9-2,2s.9,2,2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M58,23h22c1.1,0,2-.9,2-2s-.9-2-2-2h-22c-1.1,0-2,.9-2,2s.9,2,2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47,48c1.1,0,2-.9,2-2v-30c0-1.1-.9-2-2-2h-24c-1.1,0-2,.9-2,2v30c0,1.1.9,2,2,2h24ZM25,18h20v26h-20v-26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21,114h37.8c-.8-1.3-1.4-2.6-2-4H21c-1.1,0-2,.9-2,2s.9,2,2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21,104h33.9c-.3-1.3-.5-2.7-.7-4H21c-1.1,0-2,.9-2,2s.9,2,2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21,94h33.1c0-1.3.2-2.7.5-4H21c-1.1,0-2,.9-2,2s.9,2,2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19,82c0,1.1.9,2,2,2h35.1c.5-1.4,1.1-2.7,1.7-4H21c-1.1,0-2,.9-2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M65.1,70H21c-1.1,0-2,.9-2,2s.9,2,2,2h40.5c1.1-1.4,2.3-2.8,3.6-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M82.6,60.8c-.4-.5-1-.8-1.6-.8H21c-1.1,0-2,.9-2,2s.9,2,2,2h52.5c2.9-1.5,5.9-2.6,9-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12,124c-1.1,0-2-.9-2-2V6c0-1.1.9-2,2-2h78c1.1,0,2,.9,2,2v54.1c1.3,0,2.7.2,4,.5V6c0-3.3-2.7-6-6-6H12c-3.3,0-6,2.7-6,6v116c0,3.3,2.7,6,6,6h61.5c-2.2-1.1-4.2-2.5-6.1-4H12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M90,64c-17.7,0-32,14.3-32,32s14.3,32,32,32,32-14.3,32-32c0-17.7-14.3-32-32-32ZM90,124c-15.5,0-28-12.5-28-28s12.5-28,28-28,28,12.5,28,28c0,15.5-12.5,28-28,28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M105.2,82.4c-.9-.7-2.1-.5-2.8.4l-17,22.4-10.2-7.8c-.9-.7-2.1-.5-2.8.4-.7.9-.5,2.1.4,2.8l11.8,9c.9.7,2.1.5,2.8-.4l18.2-24c.7-.9.5-2.1-.4-2.8,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -540,
    y: -309,
    width: 99,
    height: 76
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaveapprove);
export default __webpack_public_path__ + "static/media/leave approve.c9a5874759a9f7ffd8749e8286b8e739.svg";
export { ForwardRef as ReactComponent };